export default {
  API_ROOT_URL: process.env.REACT_APP_API_ROOT,
  IS_DEV: false,
  TOKEN: "Wagon2021",
  LANG: "Lang",
  TIMEZONE: "TimeZone",
  USERNAME: "UserName",
  USER_ID: "UserId",
  SMS_CLICKED_YES: false, // If user clicked "Yes" in SMS reminder modal
  JUST_UNSUBSCRIBED: "JustUnsubscribed",
  DISCLAIMER_ACCEPTED: "DisclaimerAccepted",
  AUTO_LOGOUT_ENABLED:
    (process.env.REACT_APP_AUTO_LOGOUT_ENABLED ?? "true").toLowerCase() ===
    "true",
  AUTO_LOGOUT_MINUTES: parseInt(
    process.env.REACT_APP_AUTO_LOGOUT_MINUTES ?? "120",
    10,
  ),
  STAY_LOGGED_IN_HOURS: parseInt(
    process.env.REACT_APP_STAY_LOGGED_IN_HOURS ?? "8",
    10,
  ),
  STAY_LOGGED_IN_UNTIL: "StayLoggedInUntil",
};
